/**------------------------------------------------------
 * Enum Definitions
 */
export enum EnumNgRadioButtonGroupSize {
	Small 	= 'sm',
	Medium	= 'md',
	Large	= 'lg'
}


/**------------------------------------------------------
 * Radio Button Group Interfaces
 */
export interface INgRadioButtonOptions {
	// ...
	btnClass   ?: string;
	btnStyle   ?: Record<string, any>;
}

export interface INgRadioButton {
	code	 	: string;
	name	 	: string;
	icon	   ?: string;
	faIcon	   ?: string;
	tooltip	   ?: string;
	disabled   ?: boolean;
}
